import { render, staticRenderFns } from "./habitation.vue?vue&type=template&id=1c192d34&scoped=true"
import script from "./habitation.vue?vue&type=script&lang=js"
export * from "./habitation.vue?vue&type=script&lang=js"
import style0 from "./habitation.vue?vue&type=style&index=0&id=1c192d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c192d34",
  null
  
)

export default component.exports